import React, {FC} from 'react';
import InfoCardLoader from "../deprecatedUikit/InfoCard/InfoCardLoader";

interface InfoCardLoadingSkeletonProps {
  cards?: number
}

/**
 * Renders a list of loading InfoCardLoaders.
 *
 * @param [cards=10] The number of cards to render.
 * @returns InfoCardLoader[]
 */
const InfoCardLoadingSkeleton: FC<InfoCardLoadingSkeletonProps> = ({cards = 10}) => {
  return Array.from({length: cards}, (_, index) => (<InfoCardLoader key={index}/>))
};

export default InfoCardLoadingSkeleton;
